@if (loading) {
  <div
    style="
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <kendo-circularprogressbar
      style="height: 180px; width: 180px"
      [progressColor]="'#79b6ff'"
      [indeterminate]="true"
      [value]="25"
    >
    </kendo-circularprogressbar>
  </div>
  <app-spacer />
  <h4 style="width: 100%; text-align: center">
    {{ "bookingHandler.onlinePayment.wait" | translate }}
  </h4>
} @else {
  <div style="display: flex; flex-direction: column">
    <section>
      @if (error) {
        <div style="width: 100%">
          <kendo-svg-icon [icon]="icons.exclamationCircleIcon"></kendo-svg-icon>
        </div>
        <h1>{{ "attention" | translate }}</h1>
        <h4>
          @switch (error.code) {
            @case (601) {
              {{ "bookingHandler.orderNotFound" | translate }}
            }
            @case (602) {
              {{ "bookingHandler.orderNotFound" | translate }}
            }
            @case (603) {
              {{ "bookingHandler.paymentNotFound" | translate }}
            }
            @default {
              <div>{{ error.resultCode }} {{ error.resultDescription }}</div>
              <div>{{ "bookingHandler.paymentFailed" | translate }}</div>
            }
          }
        </h4>
      } @else if (contractId && pdfLink) {
        <div style="width: 100%">
          <kendo-svg-icon [icon]="icons.checkOutlineIcon"></kendo-svg-icon>
        </div>
        <h1>
          {{
            "bookingHandler.onlinePaymentConfirm"
              | translate
              | replace: "[contractId]" : contractId
          }}
        </h1>
        <h4>{{ "bookingHandler.mailConfirmSent" | translate }}</h4>
        <h4
          [innerHTML]="
            'bookingHandler.printInvoiceConfirmation'
              | translate
              | replace
                : '[link]'
                : '<a target=\'_blank\' href=' +
                    pdfLink +
                    '>' +
                    ('bookingHandler.hereDownload' | translate) +
                    '</a>'
          "
        ></h4>
        <h4>{{ "bookingHandler.greetings" | translate }}</h4>
        <h4>
          {{ "bookingHandler.forQuestionsContactUs" | translate
          }}<a
            [href]="
              'mailto:order@papinsport.com?subject=' +
              mail.subject +
              '&body=' +
              mail.body
            "
            target="_blank"
            >order&#64;papinsport.com</a
          >
        </h4>
      }
    </section>
    <app-spacer />
    <div class="k-text-center">
      @if (error && error.code === 200 && error?.resultCode !== succeedCode) {
        <button
          type="button"
          kendoButton
          size="large"
          themeColor="primary"
          (click)="tryAgain()"
        >
          {{ "bookingHandler.tryAgain" | translate }}
        </button>
        <app-spacer />
      }
      <button
        type="button"
        kendoButton
        size="large"
        themeColor="primary"
        [fillMode]="
          error?.code && error.code > 600 && error.code < 604
            ? 'solid'
            : 'outline'
        "
        (click)="resetForm()"
      >
        {{ "bookingHandler.createNewOrder" | translate }}
      </button>
    </div>
  </div>
}
